import { Component, OnInit, ViewChild } from '@angular/core';
import { Role } from './role';
import { RoleService } from './role.service';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { Status } from '../status/status';
import { StatusService } from '../status/status.service';

@Component({
    templateUrl: './role.component.html'
})

export class RoleComponent implements OnInit {

    @ViewChild('myTable') myTable;

    items: Role[] = [];
    item: Role = new Role();
    outItem: Role;
    selectedItem: Role;

    msgs: Message[] = [];
    statuslist:Status[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private service: RoleService,
        private statusService: StatusService,
    ) { }

    ngOnInit() {
        this.statusService.findAll().subscribe(status => {
            this.statuslist = status.filter(x => x.type == "Master");
        });

        this.activatedRoute.params.subscribe(params => {
            this.items = this.activatedRoute.snapshot.data['items'];
        });
    }

    newItem() {
        this.msgs = [];
        this.selectedItem = new Role();
        this.items = [this.selectedItem].concat(this.items);
        this.myTable.first = 0;
    }

    delete(item: Role) {
        this.msgs = [];
        if (item.id != null){
           this.service.delete(item).subscribe( (data) => {
            const deletedItem = this.items.find(x => x.id === item.id);
            this.items.splice(this.items.indexOf(deletedItem), 1);
            this.msgs.push({
                severity: 'success',
                detail: 'Registro excluído'
            });
           }, (err) => {
            this.msgs.push({
                severity: 'error',
                detail: 'Não é possível excluir o registro'
            });
           });
        }
    }

    save(item: Role) {
        this.msgs = [];
        if (item.description == null)   this.msgs.push({severity:'error', detail:'Descrição obrigatória'});
        if (item.status == null)        this.msgs.push({severity:'error', detail:'Status obrigatório'});

        if (this.msgs.length > 0)
            return;

        if (item.id == null){
            this.service.save(item).subscribe( params => {
                item.id = params.id;

                this.msgs.push({
                    severity: 'success',
                    detail: 'Registro incluído'
                });
            });
        } else {
            this.service.update(item).subscribe((data) => {
                this.msgs.push({
                    severity: 'success',
                    detail: 'Registro modificado'
                });
            });
        }
        this.selectedItem = null;
    }

    cancel(item : Role) {
        this.msgs = [];
        if (this.selectedItem.id == null) {
            this.items.shift();
        }

        if(this.outItem != null && this.outItem.id != null){
            item.description = this.outItem.description;
            item.status = this.outItem.status;
        }

        this.selectedItem = null;
        this.outItem = null;
    }

    edit(item: Role) {
        this.msgs = [];
        this.selectedItem = item;
        this.outItem = this.clone(item);
    }

    clone(i: Role): Role{
        let item = new Role();
        for(let prop in i){
            item[prop] = i[prop];
        }
        return item;
    }

}